module.exports = __webpack_public_path__ + "img/empreendimento-logo-6.251bb25c.png";